
import { companyLogoHandler } from "@/mixins";

    export default {

        name: 'ShareSimilarShares',
        mixins: [companyLogoHandler],
        props: {
            share: Object
        },

        methods: {
            getCompanyLogoClass(logo) {
                return (logo && logo != null) ? 'company-logo' : 'company-logo-invalid'
            },
        },
    }
